import { CallResponseDTO } from 'typings/dto/call';
import Mapper from './Mapper';

export default class CallMapper extends Mapper<Call, CallResponseDTO> {
  constructor() {
    super(
      {
        callbackless: 'callbackless',
        callerPhone: 'callerPhone',
        date: 'date',
        duration: 'duration',
        participantСalls: 'participantСalls',
        recordLink: 'recordLink',
        status: 'status',
        type: 'type',
      }
    );
  }
}
